/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AvailabilityInput {
  available_now = "available_now",
  preorder = "preorder",
  trunkshow = "trunkshow",
}

export enum Gender {
  women = "women",
}

export enum ReturnPolicy {
  extended_holidays = "extended_holidays",
  final_sale = "final_sale",
  full_refund = "full_refund",
  full_refund_markdown = "full_refund_markdown",
  site_credit = "site_credit",
  site_credit_markdown = "site_credit_markdown",
}

export enum TextAlignType {
  center = "center",
  left = "left",
  right = "right",
}

export interface PriceRange {
  min?: number | null;
  max?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
